import { createStore, compose, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
// reducer
import rootReducer from 'store/reducers';

const middlewares = [thunk];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default createStore(rootReducer, composeEnhancers(applyMiddleware(...middlewares)));
